const data = [
  {
    id: "dashboards",
    icon: "iconsminds-shop-4",
    label: "menu.dashboards",
    subs: [
      {
        icon: "simple-icon-rocket",
        label: "menu.marketing-dashboard",
        to: "/app/dashboards/marketing-dashboard"
      },
      {
        icon: "simple-icon-briefcase",
        label: "menu.merchant-dashboard",
        to: "/app/dashboards/merchant-dashboard"
      },
      {
        icon: "simple-icon-briefcase",
        label: "menu.sales-dashboard",
        to: "/app/dashboards/sales-dashboard"
      },
    ]
  },
  {
    id: "setup",
    icon: "iconsminds-digital-drawing",
    label: "menu.setup",
    subs: [
      {
        id: "setup.business-type",
        icon: "simple-icon-notebook",
        label: "menu.business-type",
        to: { name: "business-type" },
      },
      {
        id: "setup.business-location",
        icon: "simple-icon-map",
        label: "menu.business-location",
        to: { name: "business-location" },
      },
      {
        id: "setup.global-points",
        icon: "simple-icon-star",
        label: "menu.global-points",
        to: { name: "global-points" }
      },
      {
        id: "setup.payment",
        icon: "simple-icon-credit-card",
        label: "menu.payment",
        to: { name: "payment" }
      },
      {
        id: "setup.email-provider",
        icon: "simple-icon-envelope",
        label: "menu.email-provider",
        to: { name: "email-provider" }
      },
      {
        id: "setup.telnyx-settings",
        icon: "simple-icon-phone",
        label: "menu.telnyx-settings",
        to: { name: "telnyx-settings" }
      },
      {
        id: "setup.social-media-accounts",
        icon: "simple-icon-picture",
        label: "menu.social-media-accounts",
        to: { name: "social-media-accounts" }
      },
      {
        id: "setup.integrations",
        icon: "simple-icon-layers",
        label: "menu.integrations",
        to: { name: "integrations" }
      },
      {
        id: "setup.subscriptions",
        icon: "simple-icon-energy",
        label: "menu.subscriptions",
        to: { name: "subscriptions" }
      }
    ]
  },
  {
    id: "products",
    icon: "iconsminds-mine",
    label: "menu.products",
    subs: [
      {
        id: "products.product-groups",
        icon: "simple-icon-notebook",
        label: "menu.product-groups",
        to: { name: "product-groups" },
      },
      {
        id: "products.products",
        icon: "simple-icon-list",
        label: "menu.products",
        to: { name: 'products' },
      },
      {
        id: "products.addon-groups",
        icon: "iconsminds-box-close",
        label: "menu.addon-groups",
        to: { name: "addon-groups" },
      },
      {
        id: "products.addons",
        icon: "iconsminds-box-with-folders",
        label: "menu.addons",
        to: { name: "addons" },
      },
    ]
  },
  {
    id: "promotions",
    icon: "iconsminds-gift-box",
    label: "menu.promotions",
    subs: [
      {
        id: "promotions.promotions-main",
        icon: "simple-icon-badge",
        label: "menu.promotions-main",
        to: { name: "promotions-main" },
      },
      {
        id: "promotions.new-perk",
        icon: "iconsminds-add",
        label: "menu.promotions-new",
        to: { name: "promotions-new" },
      },
      {
        id: "promotions.rewards",
        icon: "iconsminds-crown-2",
        label: "menu.promotions-reward",
        to: { name: "promotions-rewards" },
      },
    ]
  },
  {
    id: "social-media-posting",
    icon: "simple-icon-picture",
    label: "menu.social-media-posting",
    subs: [
      {
        id: "social-media-posting.compose",
        icon: "simple-icon-pencil",
        label: "menu.compose-post",
        to: { name: "compose-post" },
      },
      {
        id: "social-media-posting.your-posts",
        icon: "simple-icon-picture",
        label: "menu.your-posts",
        to: { name: "your-posts" },
      },
      {
        id: "social-media-posting.ai-post-generator",
        icon: "iconsminds-brain",
        label: "menu.ai-post-generator",
        to: { name: "choose-post-type" },
      },
      {
        id: "social-media-posting.engagement",
        icon: "simple-icon-chart",
        label: "menu.engagement",
        to: { name: "engagement" },
      },
      {
        id: "social-media-posting.schedule",
        icon: "simple-icon-clock",
        label: "menu.schedule",
        to: { name: "schedule" },
      },
    ]
  },
  {
    id: "social-listening",
    icon: "simple-icon-earphones-alt",
    label: "menu.social-listening",
    subs: [
      {
        id: "social-listening.mentions",
        icon: "simple-icon-speech",
        label: "menu.mentions",
        to: { name: "mentions" },
      },
      {
        id: "social-listening.insights",
        icon: "simple-icon-graph",
        label: "menu.listening-insights",
        to: { name: "listening-insights" },
      },
    ]
  },
  {
    id: "gain-customers",
    icon: "iconsminds-target",
    label: "menu.gain-customers",
    subs: [
      {
        id: "gain-customers.reddit",
        icon: "simple-icon-social-reddit",
        label: "menu.reddit-leads",
        to: { name: "reddit-leads" },
      },
      {
        id: "gain-customers.leads",
        icon: "simple-icon-people",
        label: "menu.all-leads",
        to: { name: "all-leads" },
      },
      {
        id: "gain-customers.email-marketing",
        icon: "simple-icon-envelope",
        label: "menu.email-marketing",
        to: { name: "email-marketing" },
      },
      {
        id: "gain-customers.fax",
        icon: "simple-icon-printer",
        label: "menu.fax-center",
        to: { name: "fax-center" },
      },
      {
        id: "gain-customers.email-sequences",
        icon: "simple-icon-layers",
        label: "menu.email-sequences",
        to: { name: "email-sequences" },
      },
      {
        id: "gain-customers.contacts",
        icon: "simple-icon-user",
        label: "menu.contacts",
        to: { name: "contacts" },
      },
    ]
  },
  {
    id: "report",
    icon: "iconsminds-statistic",
    label: "menu.report",
    subs: [
      {
        id: "report.order-history",
        icon: "simple-icon-notebook",
        label: "menu.order-history",
        to: { name: "order-history" },
      },
    ]
  },
  {
    id: "support",
    icon: "simple-icon-support",
    label: "menu.support",
    subs: [
      {
        id: "support.default",
        icon: "simple-icon-support",
        label: "menu.support",
        to: { name: "support-main" },
      },
    ]
  }
];
export default data;
